<div class="client-additional-info-request-dashboard">
    <app-dashboard 
        mainSummaryText="<ol><li>client-additional-info-request-dashboard</li></ol>"
        [isClientAdditionalInfoRequest]="true"
    ></app-dashboard>
</div>
